import moment from "moment";
import { Button } from "primereact/button";
import { Calendar } from "primereact/calendar";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { Toast } from "primereact/toast";
import { Toolbar } from "primereact/toolbar";
import React, { useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import {
  defaultPageRowOptions,
  defaultRowOptions,
  paginatorLinks,
  showingEntries,
  SkeletonbodyTemplate,
  Skeletonitems,
} from "../../appconfig/Settings";
import { ROEListColumns } from "../../appconfig/DatatableSetting";
import { Column } from "primereact/column";
import { Dialog } from "primereact/dialog";
import { getAllDetails, postSingleData } from "../../service/ProductService";
import { GET_ROE_LIST, RE_GENERATE_ROE } from "../../config/ApiConstant";
import { commonNestedFieldTemplate } from "../../appconfig/TemplateFieldSetting";
import { formatDate } from "../../appconfig/AppHelper";
import { InputText } from "primereact/inputtext";
import { FilterMatchMode } from "primereact/api";

const RecordOfEmployment = () => {
  document.title = "ROE | Nexawage Payroll";
  const toast = useRef<any>(null);
  const [pageLoad, setPageLoad] = useState<boolean>(false);
  const [employeeList, setEmployeeList] = useState<any>([]);

  const currentYear = moment().year();
  const [selectedYear, setSelectedYear] = useState<number>(currentYear);
  const [roeSummaryDialog, setRoeSummaryDialog] = useState<boolean>(false);
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);

  // filters
  const [globalFilter, setGlobalFilter] = useState<any>(null);
  const [globalFieldFilter, setGlobalFieldFilter] = useState<any>(null);

  const emptyFilters = {
    global: {
      value: null,
      matchMode: FilterMatchMode.CONTAINS,
    },
  };
  const [filters, setFilters] = useState(emptyFilters);

  // selected row id
  const [selectedRowId, setSelectedRowId] = useState<any>();

  // get userData from local storage
  const rawUserData = localStorage.getItem("user_data");
  let userData: any = null;
  userData = rawUserData ? JSON.parse(rawUserData) : null;

  const userRole = userData?.roles?.role_name || "";

  // get client id from param
  const { id }: any = useParams();
  const clientId = id ? atob(id) : null;

  // useefect for get ROE list
  useEffect(() => {
    getRecordOfEmploymentList();
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedYear]);

  // list-employee
  const getRecordOfEmploymentList = async () => {
    try {
      // select id based on user role
      let idToSend = null;
      let emp_id = null;
      if (userRole === "Client") {
        idToSend = userData?.id;
      } else if (userRole === "Employee") {
        emp_id = userData?.id;
      } else {
        idToSend = clientId;
      }

      const response = await getAllDetails(`${GET_ROE_LIST}/${idToSend}?year=${selectedYear}`);

      const data = response;
      if (data) {
        setEmployeeList(data || []);
        setPageLoad(true);
      } else {
        setEmployeeList([]);
        setPageLoad(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error.response?.data?.message,
      });
      setPageLoad(false);
    }
  };

  // ROE dialog
  const ROEDialog = async (rowData: any) => {
    setRoeSummaryDialog(true);
    setSelectedRowId(rowData?.id);
  };

  // submit ROE  dialog
  const generateROE = async () => {
    setSubmitLoading(true);
    try {
      // select id based on user role
      let clientIdToUse = null;
      if (userRole === "User") {
        clientIdToUse = clientId;
      } else if (userRole === "Client") {
        clientIdToUse = userData?.id;
      }

      const response = await postSingleData(`${RE_GENERATE_ROE}/${selectedRowId}`);

      if (response) {
        if (!window.cn(response?.data)) {
          const summary_pdf = response?.data;
          setTimeout(() => {
            window.open(summary_pdf, "_blank");
          }, 1000);
        }
        setPageLoad(true);
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: response.message,
        });
        hideROEDialog();
        getRecordOfEmploymentList();
        setSubmitLoading(false);
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: error?.response?.data.message,
      });
    } finally {
      setSubmitLoading(false);
    }
  };

  // hide ROE modal
  const hideROEDialog = () => {
    setRoeSummaryDialog(false);
    setSubmitLoading(false);
  };

  // clear all filter
  const clearAll = () => {
    setFilters({ ...emptyFilters });
    setSelectedYear(currentYear);
    setGlobalFieldFilter(null);
    setGlobalFilter(null);
  };

  // left toolbar template
  const leftToolbarTemplate = () => (
    <>
      {/* <span className="block mr-2 p-input-icon-left">
        <i className="pi pi-search" />
        <InputText type="search" value={globalFilter || ""} onInput={(e) => setGlobalFilter(e.currentTarget.value)} placeholder="Search..." />
      </span> */}
    </>
  );

  // right toolbar template
  const rightToolbarTemplate = () => (
    <div className="payrollreport-template">
      {userRole !== "Employee" && (
        <>
          {/* <Button icon="pi pi-filter-slash" label="Clear" onClick={() => clearAll()} className="mr-3 p-button-outlined common-p-outline-button" /> */}

          <Calendar
            id="year"
            value={moment(selectedYear, "YYYY").toDate()}
            onChange={(e) => {
              const selectedDate = e.value;
              if (selectedDate instanceof Date) {
                const year = moment(selectedDate).year();
                setSelectedYear(year);
              }
            }}
            view="year"
            dateFormat="yy"
            showIcon
            placeholder="Filter by year"
            className="mr-2 w-15rem"
          />

          {/* <Button className="ml-1 common-primary-button mr-3" icon="pi pi-plus" label="Generate ROE" onClick={() => ROEDialog()} /> */}
        </>
      )}
    </div>
  );

  // view pdf
  const viewPdf = (rowData: any) => {
    if (rowData?.roe_url) {
      window.open(rowData?.roe_url, "_blank");
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "PDF NOT FOUND",
      });
    }
  };

  // action body template
  const actionBodyTemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-file-pdf"
        tooltip="View PDF"
        className="p-button-secondary common-view-pdf-btn"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => viewPdf(rowData)}
      />
    </div>
  );

  // view xml
  const viewXml = (rowData: any) => {
    if (rowData?.roe_xml) {
      window.open(rowData?.roe_xml, "_blank");
    } else {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "XML NOT FOUND",
      });
    }
  };

  // xml body template
  const xmlBodyTemplate = (rowData: any) =>
    rowData?.roe_xml ? (
      <div className="actions">
        <Button
          icon="pi pi-file-excel"
          tooltip="View ROE BLK"
          className="p-button-secondary common-view-pdf-btn"
          tooltipOptions={{ position: "bottom" }}
          onClick={() => viewXml(rowData)}
        />
      </div>
    ) : (
      "-"
    );

  // RE generate roe template
  const reGenerateROETemplate = (rowData: any) => (
    <div className="actions">
      <Button
        icon="pi pi-replay"
        tooltip="Re Generate ROE"
        className="common-primary-button"
        tooltipOptions={{ position: "bottom" }}
        onClick={() => ROEDialog(rowData)}
      />
    </div>
  );

  //   name template
  const nameTemplate = (rowData: any) => {
    const value = rowData?.employee?.first_name ? `${rowData?.employee?.first_name}  ${rowData?.employee?.last_name}` : "-";
    return <div className="name">{value}</div>;
  };

  //   Time period template
  const timePeriodTemplate = (rowData: any) => {
    const startDate = rowData?.employee?.rejoining_date || rowData?.employee?.joining_date;
    const value =
      startDate && rowData?.employee?.emp_status_date
        ? `${formatDate(startDate)} - ${formatDate(rowData?.employee?.emp_status_date)}`
        : "-";
    return <div className="name">{value}</div>;
  };

  return (
    <>
      <div className="grid crud-demo">
        <div className="col-12">
          <Card className="bg-white lg:p-2 crud-demo">
            <Toast ref={toast} />
            <Toolbar className="gap-3" left={leftToolbarTemplate} right={rightToolbarTemplate} />
            {pageLoad ? (
              <DataTable
                value={employeeList}
                showGridlines
                responsiveLayout={"scroll"}
                dataKey="id"
                stripedRows
                rows={defaultRowOptions}
                paginator={employeeList?.length > 0}
                rowsPerPageOptions={defaultPageRowOptions}
                className="datatable-responsive p-datatble-sm"
                paginatorTemplate={paginatorLinks}
                currentPageReportTemplate={showingEntries + " ROE"}
                emptyMessage="No ROE Found"
                globalFilter={globalFilter}
                // filters={globalFieldFilter}
                // onFilter={(e) => setGlobalFieldFilter(e.filters)}
                filters={filters}
                onFilter={(e: any) => setFilters(e.filters)}
                removableSort
              >
                {ROEListColumns.map((col, i) => {
                  const colWidth = { width: "16.66%" };
                  if (col.field === "url") {
                    return <Column key={col.field} field={col.field} header={col.header} body={actionBodyTemplate} style={colWidth} />;
                  } else if (col.field === "t4blk") {
                    return <Column key={col.field} field={col.field} header={col.header} body={xmlBodyTemplate} style={colWidth} />;
                  } else if (col.field === "address") {
                    return <Column key={col.field} field={col.field} header={col.header} body={commonNestedFieldTemplate("address")} style={colWidth} />;
                  } else if (col.field === "name") {
                    return <Column key={col.field} field={col.field} header={col.header} body={nameTemplate} style={colWidth} />;
                  } else if (col.field === "re_generate_roe") {
                    return <Column key={col.field} field={col.field} header={col.header} body={reGenerateROETemplate} style={colWidth} />;
                  } else if (col.field === "time_period") {
                    return <Column key={col.field} field={col.field} header={col.header} body={timePeriodTemplate} style={colWidth} />;
                  } else {
                    return <Column key={col.field} field={col.field} header={col.header} style={colWidth} />;
                  }
                })}
              </DataTable>
            ) : (
              <DataTable value={Skeletonitems}>
                {ROEListColumns.map((col) => (
                  <Column key={col.field} field={col.field} header={col.header} body={SkeletonbodyTemplate} />
                ))}
              </DataTable>
            )}
          </Card>
        </div>
      </div>

      {/* Generate t4 dialog */}
      <Dialog
        visible={roeSummaryDialog}
        style={{ width: "600px" }}
        draggable={false}
        className="mx-3 lg:mx-0"
        header={"Re-Generate ROE (Record of Employment)"}
        modal
        footer={
          <div className="flex pt-2 align-items-center justify-content-end">
            <Button label="Cancel" icon="pi pi-times" className="mr-2 p-button-secondary" onClick={hideROEDialog} disabled={submitLoading} />
            <Button label="Submit" icon="pi pi-check" className="common-primary-button" onClick={generateROE} loading={submitLoading} />
          </div>
        }
        onHide={hideROEDialog}
      >
        <h5 className="mb-4">Do you want to Re-Generate ROE (Record Of Employment) ? </h5>
      </Dialog>
    </>
  );
};

export default RecordOfEmployment;
